import type { ReactNode } from 'react';

export interface LwDataPanelProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  ariaLabel?: string;
}

export function LwDataPanel({
  title,
  description,
  actions,
  children,
  footer,
  className,
  ariaLabel
}: LwDataPanelProps) {
  return (
    <section className={`lw-data-panel${className ? ` ${className}` : ''}`} aria-label={ariaLabel}>
      {(title || description || actions) && (
        <div className="lw-data-panel__head">
          <div>
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
          {actions && <div className="lw-data-panel__actions">{actions}</div>}
        </div>
      )}
      <div className="lw-data-panel__body">{children}</div>
      {footer && <div className="lw-data-panel__foot">{footer}</div>}
    </section>
  );
}
